import { Link } from 'react-router-dom';
import { Breadcrumbs } from '../components/navigation/Breadcrumbs';
import { HelpLayout } from '../components/layout/HelpLayout';
import { categoryLabel } from '../data/categories';
import { getVisibleArticles } from '../lib/content';
import { articlePath } from '../lib/routes';
import { ARTICLE_TYPE_LABEL } from '../types/article';
import { PROFILE_LABEL, type Profile } from '../types/profile';

const intro: Record<Profile, string> = {
  student: 'Aprenda a usar o Personagrama no seu desenvolvimento, do diagnóstico ao acompanhamento da evolução.',
  mentor: 'Acesse a experiência do Aluno e as orientações específicas para acompanhar seus Mentorados.',
  owner: 'Administre pessoas, metodologia, conteúdo, Jornadas, Formações e a operação completa do ambiente.',
};

export function ProfileHomePage({ profile }: { profile: Profile }) {
  const articles = getVisibleArticles(profile);
  const grouped = articles.reduce<Record<string, typeof articles>>((acc, article) => {
    (acc[article.meta.category] ??= []).push(article);
    return acc;
  }, {});

  return (
    <HelpLayout profile={profile}>
      <Breadcrumbs profile={profile} />
      <header className="profile-hero">
        <p className="eyebrow">Ajuda por perfil</p>
        <h1>{PROFILE_LABEL[profile]}</h1>
        <p className="lead">{intro[profile]}</p>
      </header>

      {Object.entries(grouped).map(([category, items]) => (
        <section className="category-block" key={category}>
          <h2>{categoryLabel(category)}</h2>
          <div className="article-grid">
            {items.map((article) => (
              <Link className="article-card" key={article.meta.id} to={articlePath(profile, article.meta.category, article.meta.slug)}>
                <span className="article-card-type">{ARTICLE_TYPE_LABEL[article.meta.type]}</span>
                <strong>{article.meta.title}</strong>
                <span>{article.meta.description}</span>
                <span className="card-link">Abrir artigo →</span>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </HelpLayout>
  );
}
